export const XERO_THEME_COLOR = '#13B5EA';

export const XERO_SPACING = {
  page: '40px',
  group: '32px',
  field: '16px',
  text: '10px',
};

export const XERO_COLORS = {
  heading: '#10253E',
  border: '#E3E8EF',
  inputBorder: '#C9CFD8',
  placeholder: '#6B7684',
};

export const XERO_NARROW_SCREEN = '480px';
